import { useForm, Controller } from "react-hook-form";
import FormControlLabel from "../mui/FormControlLabel";
import Typography from "../mui/Typography";
import Stack from "../mui/Stack";
import Checkbox from "../../components/mui/Checkbox";
import styled from "@emotion/styled";
import FormControl from "../mui/FormControl";
import FormHelperText from "../mui/FormHelperText";
import AutoComplete from "../mui/AutoComplete";
import Box from "../mui/Box";

interface RatioButton {
  label: string;
  value: string;
}

interface QcFilterFormProps {
  ratiobtn: RatioButton[];
  centerList: { centerSelect: { id: string; label: string }[] }; 
  filter: { center: string }; 
  handleFilterFormChange: (field: string, value: any) => void;
}

const StyledLabel = styled(Box)(({ theme }) => ({
  fontSize: "14px !important",
  marginBottom: "3px !important",
  fontWeight: "500 !important",
  color: "#191919 !important",
}));

const QcFilterForm: React.FC<QcFilterFormProps> = ({
  ratiobtn,
  centerList,
  filter,
  handleFilterFormChange,
}) => {
  const { control } = useForm();

  return (
    <Stack>
     <Stack>
        <Typography>Region</Typography>
        <Controller
          name="selectedRegion"
          control={control}
          defaultValue=""
          render={({ field: { onChange, value } }) => (
            <StyledCheckboxGroup>
              {ratiobtn.map((btn) => (
                <FormControlLabel
                  key={btn.value}
                  control={
                    <Checkbox
                      checked={value === btn.value}
                      onChange={() => onChange(btn.value)}
                      sx={{
                        "&.Mui-checked": {
                          color: "#FFCA09",
                        },
                        marginRight:"-7px"
                      }}
                    />
                  }
                  label={btn.label}
                  value={btn.value}
                />
              ))}
            </StyledCheckboxGroup>
          )}
        />
      </Stack>

      <Stack>
        <Controller
          name="filter.centers"
          control={control}
          // rules={{ required: "Centers is required" }}
          render={({ field, fieldState: { error } }) => {
            return (
              <>
                <Stack>
                  <StyledLabel>Center</StyledLabel>
                  <FormControl
                  //  error={!!errors.data?.centers}
                    fullWidth>
                    <AutoComplete
                      {...field}
                      id="Centers-select"
                      options={centerList.centerSelect}
                      // matchKey="id"
                      // labelKey="label"
                      placeholder="Select Center"
                      disableClearable={false}
                      // errorMsg={errors.data?.centers?.message}
                      loading={false}
                      // multiple={true}
                      value={field.value || []}
                      onChange={(newValue: any) => {
                        field.onChange(newValue);
                      }}
                      sx={{ backgroundColor: "#fff" }}
                    />
                    <StyledFormHelperText>
                      {error ? error.message : " "}
                    </StyledFormHelperText>
                  </FormControl>
                </Stack>
              </>
            );
          }}
        />
      </Stack>
      <Stack>
        <Controller
          name="filter.centers"
          control={control}
          // rules={{ required: "Centers is required" }}
          render={({ field, fieldState: { error } }) => {
            return (
              <>
                <Stack>
                  <StyledLabel>State</StyledLabel>
                  <FormControl
                  //  error={!!errors.data?.centers}
                    fullWidth>
                    <AutoComplete
                      {...field}
                      id="Centers-select"
                      options={centerList.centerSelect}
                      // matchKey="id"
                      // labelKey="label"
                      placeholder="Select State"
                      disableClearable={false}
                      // errorMsg={errors.data?.centers?.message}
                      loading={false}
                      // multiple={true}
                      value={field.value || []}
                      onChange={(newValue: any) => {
                        field.onChange(newValue);
                      }}
                      sx={{ backgroundColor: "#fff" }}
                    />
                    <StyledFormHelperText>
                      {error ? error.message : " "}
                    </StyledFormHelperText>
                  </FormControl>
                </Stack>
              </>
            );
          }}
        />
      </Stack>
      <Stack>
        <Controller
          name="filter.centers"
          control={control}
          // rules={{ required: "Centers is required" }}
          render={({ field, fieldState: { error } }) => {
            return (
              <>
                <Stack>
                  <StyledLabel>City</StyledLabel>
                  <FormControl
                  //  error={!!errors.data?.centers}
                    fullWidth>
                    <AutoComplete
                      {...field}
                      id="Centers-select"
                      options={centerList.centerSelect}
                      // matchKey="id"
                      // labelKey="label"
                      placeholder="Select City"
                      disableClearable={false}
                      // errorMsg={errors.data?.centers?.message}
                      loading={false}
                      // multiple={true}
                      value={field.value || []}
                      onChange={(newValue: any) => {
                        field.onChange(newValue);
                      }}
                      sx={{ backgroundColor: "#fff" }}
                    />
                    <StyledFormHelperText>
                      {error ? error.message : " "}
                    </StyledFormHelperText>
                  </FormControl>
                </Stack>
              </>
            );
          }}
        />
      </Stack>
      <Stack>
        <Controller
          name="filter.centers"
          control={control}
          // rules={{ required: "Centers is required" }}
          render={({ field, fieldState: { error } }) => {
            return (
              <>
                <Stack>
                  <StyledLabel>Program Performance Parameter</StyledLabel>
                  <FormControl
                  //  error={!!errors.data?.centers}
                    fullWidth>
                    <AutoComplete
                      {...field}
                      id="Centers-select"
                      options={centerList.centerSelect}
                      // matchKey="id"
                      // labelKey="label"
                      placeholder="Select Program Performance Parameter"
                      disableClearable={false}
                      // errorMsg={errors.data?.centers?.message}
                      loading={false}
                      // multiple={true}
                      value={field.value || []}
                      onChange={(newValue: any) => {
                        field.onChange(newValue);
                      }}
                      sx={{ backgroundColor: "#fff" }}
                    />
                    <StyledFormHelperText>
                      {error ? error.message : " "}
                    </StyledFormHelperText>
                  </FormControl>
                </Stack>
              </>
            );
          }}
        />
      </Stack>
      <Stack>
        <Controller
          name="filter.centers"
          control={control}
          // rules={{ required: "Centers is required" }}
          render={({ field, fieldState: { error } }) => {
            return (
              <>
                <Stack>
                  <StyledLabel>Quality and Efficacy Parameter</StyledLabel>
                  <FormControl
                  //  error={!!errors.data?.centers}
                    fullWidth>
                    <AutoComplete
                      {...field}
                      id="Centers-select"
                      options={centerList.centerSelect}
                      // matchKey="id"
                      // labelKey="label"
                      placeholder="Select Quality and Efficacy Parameter"
                      disableClearable={false}
                      // errorMsg={errors.data?.centers?.message}
                      loading={false}
                      // multiple={true}
                      value={field.value || []}
                      onChange={(newValue: any) => {
                        field.onChange(newValue);
                      }}
                      sx={{ backgroundColor: "#fff" }}
                    />
                    <StyledFormHelperText>
                      {error ? error.message : " "}
                    </StyledFormHelperText>
                  </FormControl>
                </Stack>
              </>
            );
          }}
        />
      </Stack>
      <Stack>
        <Controller
          name="filter.centers"
          control={control}
          // rules={{ required: "Centers is required" }}
          render={({ field, fieldState: { error } }) => {
            return (
              <>
                <Stack>
                  <StyledLabel>Funder</StyledLabel>
                  <FormControl
                  //  error={!!errors.data?.centers}
                    fullWidth>
                    <AutoComplete
                      {...field}
                      id="Centers-select"
                      options={centerList.centerSelect}
                      // matchKey="id"
                      // labelKey="label"
                      placeholder="Select Funder"
                      disableClearable={false}
                      // errorMsg={errors.data?.centers?.message}
                      loading={false}
                      // multiple={true}
                      value={field.value || []}
                      onChange={(newValue: any) => {
                        field.onChange(newValue);
                      }}
                      sx={{ backgroundColor: "#fff" }}
                    />
                    <StyledFormHelperText>
                      {error ? error.message : " "}
                    </StyledFormHelperText>
                  </FormControl>
                </Stack>
              </>
            );
          }}
        />
      </Stack>
      <Stack>
        <Controller
          name="filter.centers"
          control={control}
          // rules={{ required: "Centers is required" }}
          render={({ field, fieldState: { error } }) => {
            return (
              <>
                <Stack>
                  <StyledLabel>Regional Director</StyledLabel>
                  <FormControl
                  //  error={!!errors.data?.centers}
                    fullWidth>
                    <AutoComplete
                      {...field}
                      id="Centers-select"
                      options={centerList.centerSelect}
                      // matchKey="id"
                      // labelKey="label"
                      placeholder="Select Regional Director"
                      disableClearable={false}
                      // errorMsg={errors.data?.centers?.message}
                      loading={false}
                      // multiple={true}
                      value={field.value || []}
                      onChange={(newValue: any) => {
                        field.onChange(newValue);
                      }}
                      sx={{ backgroundColor: "#fff" }}
                    />
                    <StyledFormHelperText>
                      {error ? error.message : " "}
                    </StyledFormHelperText>
                  </FormControl>
                </Stack>
              </>
            );
          }}
        />
      </Stack>
      <Stack>
        <Controller
          name="filter.centers"
          control={control}
          // rules={{ required: "Centers is required" }}
          render={({ field, fieldState: { error } }) => {
            return (
              <>
                <Stack>
                  <StyledLabel>Cluster manager</StyledLabel>
                  <FormControl
                  //  error={!!errors.data?.centers}
                    fullWidth>
                    <AutoComplete
                      {...field}
                      id="Centers-select"
                      options={centerList.centerSelect}
                      // matchKey="id"
                      // labelKey="label"
                      // placeholder="Select Cluster manager"
                      disableClearable={false}
                      // errorMsg={errors.data?.centers?.message}
                      loading={false}
                      // multiple={true}
                      value={field.value || []}
                      onChange={(newValue: any) => {
                        field.onChange(newValue);
                      }}
                      sx={{ backgroundColor: "#fff" }}
                    />
                    <StyledFormHelperText>
                      {error ? error.message : " "}
                    </StyledFormHelperText>
                  </FormControl>
                </Stack>
              </>
            );
          }}
        />
      </Stack>
    </Stack>
  );
};

const StyledCheckboxGroup = styled(Stack)({
  flexDirection: "row",
  marginRight:"8px"

});
const StyledStack = styled(Stack)(() => ({
  marginBottom: "15px",
}));

const StyledTypography = styled(Typography)(() => ({}));
const StyledFormHelperText = styled(FormHelperText)(() => ({
  marginLeft: "0px",
  color: "red",
}));

export default QcFilterForm;
